import { Box } from "@chakra-ui/react";
import { PresenceType } from "@keita/lanepatrol-sdk";
import { ColorByLegendItem } from "./ColorByLegendItem";
import {
  mapGradientEnd,
  mapGradientStart,
} from "../../../../map/utils/map-utils";
import { AttributeUtils } from "../../../../coding/utils/attribute-utils";

export const ColorByTreatment: React.FC = () => {
  return (
    <Box>
      <ColorByLegendItem color={mapGradientStart}>
        {AttributeUtils.getOptionLabel(PresenceType.Present)}
      </ColorByLegendItem>
      <ColorByLegendItem color={mapGradientEnd}>
        {AttributeUtils.getOptionLabel(PresenceType.NotPresent)}
      </ColorByLegendItem>
    </Box>
  );
};
